export const getHost = (host?: string): string => {
    if (host) {
        return host;
    }

    const location = window && window.location ? window.location : { host: '' };

    return location.host || 'www.lingoda.com'; // Fall back to www.lingoda.com;
};
